import { CompanyCustomization, CompanyCustomizationEnum, CompanyCustomizationInput } from '@Arti-zen/package-backoffice'
import SelectBase from 'components/forms/Select.base'
import { useAppSelector } from 'hooks/useStore'
import { ReactElement, useCallback, useEffect, useState } from 'react'
import { styled } from 'styled-components'
import { Theme } from 'theme/theme'
import { ApiArtizenBO } from 'utils/artizenConnector'

const SendPaymentLinkLevels = { always: 'ALWAYS', never: 'NEVER', ask_before: 'ASK_BEFORE' }

export default function ArtisanPaymentOption(): ReactElement {
  const { artisan } = useAppSelector((state) => state.artisan)
  const [currentOption, setCurrentOption] = useState<'true' | 'false' | null>(null)
  const [options, setOptions] = useState<CompanyCustomization[]>([])
  const [message, setMessage] = useState<string | null>(null)
  const [messageInsertion, setMessageInsertion] = useState<string | null>(null)

  const InputOptionActive = useCallback(
    () => (
      <SelectBase
        items={[
          { value: 'true', label: 'oui' },
          { value: 'false', label: 'non' },
        ]}
        defaultValue={currentOption}
        onChange={onChange}
      />
    ),
    [currentOption]
  )

  const InputOptionLink = useCallback(() => {
    const currentValue = options.find((option) => option.type === CompanyCustomizationEnum.SEND_PAYMENT_LINK)?.value
    
    return (
      <SelectBase
        items={Object.values(SendPaymentLinkLevels).map((option) => ({ value: option, label: option }))}
        defaultValue={currentValue}
        onChange={value => onChangeOption({ type: CompanyCustomizationEnum.SEND_PAYMENT_LINK, value })}
      />
    )
  }, [options])


  const onChangeOption = (option: CompanyCustomizationInput) => {
    setMessageInsertion('Sauvegarde en cours')
    ApiArtizenBO.artizenUsers
      .createOrUpdateOption(artisan.id, option)
      .then(() => setMessageInsertion('Option sauvegardée'))
      .catch(() => setMessageInsertion('Echec de la sauvegarde'))
  }

  const onChange = (value: 'true' | 'false') => {
    setMessage('Sauvegarde en cours')
    ApiArtizenBO.artizenUsers
      .createOrUpdatePaymentOption(artisan.id, value)
      .then(() => setMessage('Option sauvegardée'))
      .catch(() => setMessage('Echec de la sauvegarde'))
  }

  useEffect(() => {
    let isMount = true
    ApiArtizenBO.artizenUsers.getPaymentOption(artisan.id).then((option) => isMount && setCurrentOption(option?.value))
    ApiArtizenBO.artizenUsers.getCompanyCustomizations(artisan.id).then((options) => isMount && setOptions(options))

    return () => {
      isMount = false
    }
  }, [])

  return (
    <>
      <Title>Option de paiement</Title>
      <div style={{ display: 'flex', flexDirection: 'row', gap: 20, alignItems: 'center' }}>
        Activation option paiment : <InputOptionActive /> <span style={{ fontSize: 12, fontStyle: 'italic' }}>{message}</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', gap: 20, alignItems: 'center' }}>
        Methode insertion lien paiment : <InputOptionLink /> <span style={{ fontSize: 12, fontStyle: 'italic' }}>{messageInsertion}</span>
      </div>
    </>
  )
}

const Title = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  ${Theme.font.size.xlarge};
  font-weight: 700;
  border-bottom: 1px solid;
`
